export type SlideWheelDirection = 'next' | 'prev';

const WHEEL_COOLDOWN_MS = 200;

export function shouldIgnoreSlideWheelTarget(target: EventTarget | null): boolean {
  const el = target instanceof HTMLElement ? target : null;
  if (!el) return false;
  return (
    el.isContentEditable ||
    el.getAttribute?.('contenteditable') === 'true' ||
    /^(input|textarea|select)$/i.test(el.tagName)
  );
}

export function shouldIgnoreSlideWheelEvent(event: WheelEvent): boolean {
  if (typeof document === 'undefined') return shouldIgnoreSlideWheelTarget(event.target);
  return shouldIgnoreSlideWheelTarget(event.target) || shouldIgnoreSlideWheelTarget(document.activeElement);
}

export function getSlideWheelDirection(event: WheelEvent): SlideWheelDirection | null {
  const dominantDelta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
  if (dominantDelta === 0) return null;
  return dominantDelta > 0 ? 'next' : 'prev';
}

export function createSlideWheelHandler(options: {
  onNext: () => void;
  onPrev: () => void;
}): (event: WheelEvent) => void {
  let lastNavigationAt = 0;

  return (event: WheelEvent) => {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    if (shouldIgnoreSlideWheelEvent(event)) return;

    const direction = getSlideWheelDirection(event);
    if (!direction) return;

    const now = Date.now();
    if (now - lastNavigationAt < WHEEL_COOLDOWN_MS) {
      event.preventDefault();
      return;
    }
    lastNavigationAt = now;
    event.preventDefault();

    if (direction === 'next') {
      options.onNext();
    } else {
      options.onPrev();
    }
  };
}
